import { object, string } from "yup";

export const statementsValidations = object({
  account_subtype: string()
    .required("Account type is required")
    .oneOf(["checking", "savings"], "Invalid account type"),
  account_number: string()
    .required("Account number is required")
    .matches(/^\d+$/, "Account number must be numeric")
    .min(5, "Account number must be at least 5 digits long")
    .max(17, "Account number cannot be longer than 17 digits"),
  routing_number: string()
    .required("Routing number is required")
    .matches(/^\d+$/, "Routing number must be numeric")
    .length(9, "Routing number must be 9 digits long"),
  name: string()
    .required("Account name is required")
    .max(255, "Account nickname is too long")
});
